export function you(name) {
    return {
        i : name ? name: "I",
        you : name ? name:  "you",
        your : name ? name + "'s" :  "your",
        doYou : name ? "does " + name:  "do you",
        haveYou : name ? "has " + name:  "have you",
        areYou : name ? "is " + name:  "are you",
        wereYou : name ? "was " + name:  "were you",
    }
}
export function capitaliseFirst(string){
    if (string){
        return string.toString().charAt(0).toUpperCase() + string.slice(1);
    }
    return ''
}